import { unregisterFcmTokenForSession } from "../services/fcm.service";

/**
 * Unregister the current browser FCM token before auth storage is cleared.
 */
export async function unregisterFcmBeforeLogout() {
  try {
    const authInfo = JSON.parse(localStorage.getItem("authInfo") || "null");
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "null");
    if (!authInfo || !userInfo) {
      return;
    }
    await unregisterFcmTokenForSession(authInfo, userInfo);
  } catch (error) {
    console.warn("[FCM] unregisterFcmBeforeLogout failed:", error.message);
  }
}
